export default __webpack_public_path__ + "static/media/Inactive_Pink.d9f78885.svg";